import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateCadastroPesquisaItensCadastroColumnDefinition
 */

type Props = {
  onActionEditar: (idItemPesquisaSatisfacao: number | null, openState: boolean) => void;
  onActionDelete: (idItemPesquisaSatisfacao: number | null, openState: boolean) => void;
};

export const GenerateCadastroPesquisaItensCadastroColumnDefinition = ({
  onActionEditar,
  onActionDelete,
}: Props): GridColDef[] => {
  return [
    {
      field: "ordem",
      filterable: false,
      headerName: "Ordem",
      width: 200,
      minWidth: 200,
      sortable: false,
      align: 'left',
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Item",
      flex: 1,
      minWidth: 200,
      sortable: false,
      align: 'left',
    },
    {
      field: 'idItemPesquisaSatisfacao',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                onActionEditar(value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDelete(value, true); }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}